// extracted by mini-css-extract-plugin
export default {"socialBlockArticle":"SocialBlockArticle_socialBlockArticle__vISl+","iconWrapper":"SocialBlockArticle_iconWrapper__eglVs","icon":"SocialBlockArticle_icon__HeJwY"};